// extracted by mini-css-extract-plugin
module.exports = {"logo":"layout_logo__fwOr-","siteLayout":"layout_siteLayout__1DKBE","site-layout-background":"layout_site-layout-background__2fzfR","site-layout":"layout_site-layout__2jNDA"};